<template>
  <div class="asta-tavolo">
    <div class="area-logs">
      <div class="area-logs-spacer"></div>
      <div class="area-logs-center">
        <asta-log small hasEffect v-if="astaLogsLast" :log="astaLogsLast">
        </asta-log>
        <div v-else class="area-logs-empty">Registro Eventi</div>
        <v-btn
          @click="showAstaLogs"
          x-small

          rounded
          class="btn-logs text-none"
          ><v-icon>more_horiz</v-icon></v-btn
        >
      </div>
      <div class="area-logs-actions">
        <user-preferences-speed-dial />
      </div>
    </div>
    <!-- Listone warning -->
    <div v-if="listoneStatus != 1 && !listoneStatusClosed" class="px-4 py-1">
      <v-alert
        dense
        text
        :color="listoneStatusColor"
        icon="warning"
        class="alert-hint"
      >
        <v-btn
          icon
          x-small
          class="alert-hint-close"
          @click="closelistoneStatus"
        >
          <v-icon small>close</v-icon>
        </v-btn>
        <div>
           {{ listoneStatusMsg }}
        </div>
      </v-alert>
    </div>
    <!-- Modalita Assegna hint -->
     <div v-if="showAssegnaHint" class="px-4 py-1">
      <v-alert
        dense
        text
        color="cyan"
        icon="touch_app"
        class="alert-hint"
      >
        <v-btn
          icon
          x-small
          class="alert-hint-close"
          @click="dismissAssegnaHint"
        >
          <v-icon small>close</v-icon>
        </v-btn>
          {{ assegnaHintText }}
      </v-alert>
    </div>
    <div v-if="showAstaAssegnaInline" class="asta-assegna-inline-wrapper">
      <asta-assegna></asta-assegna>
    </div>
    <asta-tavolo-cerchio
      v-if="tavoloLayout == Constants.TAVOLO_LAYOUT.CERCHIO"
    ></asta-tavolo-cerchio>
    <asta-tavolo-griglia v-else></asta-tavolo-griglia>
    <div class="top-left-corner"></div>
    <div class="top-right-corner"></div>
  </div>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";
import AstaLog from "./common/AstaLog";
import Constants from "../js/constants";
import * as Helpers from "../js/helpers";
import mixins from "../js/mixins";
import AstaTavoloCerchio from "./AstaTavoloCerchio.vue";
import AstaTavoloGriglia from "./AstaTavoloGriglia.vue";
import AstaAssegna from "./dialogs/AstaAssegna.vue";
import UserPreferencesSpeedDial from "./common/UserPreferencesSpeedDial.vue";

export default {
  name: "asta-tavolo",
  mixins: [mixins],
  components: {
    AstaLog,
    AstaTavoloCerchio,
    AstaTavoloGriglia,
    AstaAssegna,
    UserPreferencesSpeedDial,
  },
  data() {
    return {
      listoneStatusClosed: false,
      showAssegnaHintLocal: true,
      dismissAssegnaHintDialog: false,
    };
  },
  computed: {
    showAssegnaHint() {
      return this.admin && this.mode_assegna && this.showAssegnaHintLocal;
    },
    showAstaAssegnaInline() {
      return this.admin && this.mode_assegna && this.is_calciatore_in_asta;
    },
    assegnaHintText() {
      return Helpers.assegnaHintText(this.mode_random, this.is_mobile);
    },
    listoneStatusColor() {
      if (this.listoneStatus == 0) {
        return "error";
      }
      return "orange";
    },
    ...Vuex.mapGetters([
      "astaLogsLast",
      "tavoloLayout",
      "listoneStatus",
      "listoneStatusMsg",
    ]),
  },
  methods: {
    showAstaLogs() {
      db.emit("showAstaLogs");
    },
    dismissAssegnaHint() {
      this.dismissAssegnaHintDialog = false;
      this.showAssegnaHintLocal = false;
    },
    closelistoneStatus() {
      this.listoneStatusClosed = true;
    },
  },
  mounted() {
    console.log("--> AstaTavolo ready.");
    this.showAssegnaHintLocal =
      localStorage.getItem(Constants.LS_HIDE_ASSEGNA_HINT) != "T";
  },
  destroyed() {
    console.log("<-- AstaTavolo destroyed.");
  },
};
</script>
<style lang="scss" scoped>
@import "../main.scss";

.asta-tavolo {
  // background: linear-gradient(white, transparent);
  // padding-top: 50px;
  // overflow: hidden;
  .area-logs {
    padding: 18px 8px 3px 8px;
    // background: white;
    margin-bottom: 10px;
    min-height: 40px;
    position: relative;
    z-index: 200;
    display: grid;
    grid-template-columns: minmax(34px, 1fr) auto minmax(34px, 1fr);
    align-items: center;
    column-gap: 8px;

    .area-logs-center {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 0;
    }

    .area-logs-empty {
      color: var(--v-navy-darken2);
      font-size: 12px;
      font-weight: 600;
      line-height: 1;
      opacity: 0.75;
      white-space: nowrap;
    }

    .area-logs-actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      min-width: 0;
    }

    .btn-logs {
      // position: absolute;
      // right: 5px;
      // top: 10px;
      // color: white;
      background: var(--v-navy-darken-1);
    }
  }
  .asta-assegna-inline-wrapper {
    margin: 0 auto 10px;
    max-width: 520px;
    padding: 0 12px;
  }
}

.top-left-corner {
  position: absolute;
  top: 5px;
  left: 10px;
  display: flex;
  flex-direction: column;
  .v-speed-dial__list {
    left: 10px;
  }
  .v-btn-toggle {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
    margin: 0 0px 6px 0;
    .v-item--active {
      color: var(--v-text-base);
    }
    .v-btn {
      margin: 0;
      opacity: 1;
      background: white;
    }
    &.icone-cerchi {
      .v-btn {
        &:first-child i {
          font-size: 10px;
        }

        i {
          font-size: 15px;
        }

        &:last-child i {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
